
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 12.5a.625.625 0 01-.625-.625v-.838c0-.794.502-1.505 1.25-1.769a1.878 1.878 0 001.25-1.767 1.86 1.86 0 00-.55-1.326A1.86 1.86 0 0010 5.625c-.5 0-.972.196-1.326.55A1.86 1.86 0 008.125 7.5a.626.626 0 01-1.25 0c0-.835.326-1.62.916-2.21A3.105 3.105 0 0110 4.377 3.129 3.129 0 0113.125 7.5a3.13 3.13 0 01-2.083 2.946.626.626 0 00-.417.589v.839c0 .345-.28.625-.625.625zm0 3.125a.937.937 0 100-1.875.937.937 0 000 1.875z","fill":"#666"}}),_c('path',{attrs:{"d":"M10 20C4.486 20 0 15.514 0 10S4.486 0 10 0s10 4.486 10 10-4.486 10-10 10zm0-18.75c-4.825 0-8.75 3.925-8.75 8.75s3.925 8.75 8.75 8.75 8.75-3.925 8.75-8.75S14.825 1.25 10 1.25z","fill":"#666"}})])
          )
        }
      }
    